import { render, staticRenderFns } from "./AddSubAccount.component.vue?vue&type=template&id=6d1c1413&"
import script from "./AddSubAccount.component.vue?vue&type=script&lang=ts&"
export * from "./AddSubAccount.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports